/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { toast } from "react-toastify";

export const showSimpleInfo = (
  text: string,
  autoClose: false | number = 2000
) =>
  toast.info(text, {
    position: "top-right",
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const showSuccess = (
  text: string,
  autoClose: false | number = 2000,
  onClick?: () => void
) =>
  toast.success(text, {
    position: "top-right",
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClick: onClick || undefined,
  });

export const showToastError = (
  text: string,
  autoClose: false | number = 2000,
  onClick?: () => void,
  onClose?: () => void
  // eslint-disable-next-line max-params
) =>
  toast.error(text, {
    autoClose,
    position: "top-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClick: onClick || undefined,
    onClose: onClose || undefined,
  });
